import { z } from 'zod'

import { camelizeKeys } from '@/functions/utils/camelize-keys'

import { BASKET_TYPE } from '@/components/sales/checkout/consts'

const PaymentsAppointmentDetailsAmountBaseSchema = z.object({
  amount: z.number(),
  amount_formatted: z.string(),
})

const PaymentsAppointmentDetailsStatusBaseSchema = z.object({
  code: z.string(),
  label: z.string(),
})

const PaymentsAppointmentDetailsSummaryBaseSchema = z.object({
  total: PaymentsAppointmentDetailsAmountBaseSchema,
  already_paid: PaymentsAppointmentDetailsAmountBaseSchema,
  remaining: PaymentsAppointmentDetailsAmountBaseSchema,
})

const AppointmentPaymentBaseSchema = z.object({
  id: z.string(),
  status: PaymentsAppointmentDetailsStatusBaseSchema,
  payment_type_code: z.string(),
  amount: z.number(),
  amount_formatted: z.string(),
  created: z.string(),
  basket_id: z.string(),
  basket_type: z.string(),
  deposit_status: z.string().nullable().optional(),
  transaction_id: z.union([z.number(), z.string()]),
  payment_details_label: z.string(),
  is_refundable: z.boolean(),
  fiscal_receipt: z.unknown().nullable().optional(),
})

const PaymentsAppointmentDetailsBaseSchema = z.object({
  handle_deposit: z.boolean(),
  payable: z.boolean(),
  auto_release_deposit_on_cancel: z.boolean().nullable(),
  payments_summary: PaymentsAppointmentDetailsSummaryBaseSchema,
  appointment_payments: z.array(AppointmentPaymentBaseSchema),
})

export const AppointmentPaymentSchema = AppointmentPaymentBaseSchema.transform(camelizeKeys)

const PaymentsAppointmentDetailsAmountSchema = PaymentsAppointmentDetailsAmountBaseSchema.transform(camelizeKeys)
const PaymentsAppointmentDetailsStatusSchema = PaymentsAppointmentDetailsStatusBaseSchema.transform(camelizeKeys)
const PaymentsAppointmentDetailsSummarySchema = PaymentsAppointmentDetailsSummaryBaseSchema.transform(camelizeKeys)

export const PaymentsAppointmentDetailsSchema = PaymentsAppointmentDetailsBaseSchema.transform((data) => {
  const camelized = camelizeKeys(data)

  return {
    ...camelized,
    depositInfo: camelized.appointmentPayments.find(payment => payment.basketType === BASKET_TYPE.DEPOSIT) ?? null,
    transactionInfo: camelized.appointmentPayments.find(payment => payment.basketType === BASKET_TYPE.PAYMENT) ?? null,
  }
})

export const GetPaymentsAppointmentDetailsResponseSchema = z.object({
  result: PaymentsAppointmentDetailsSchema,
})

export type PaymentsAppointmentDetailsAmount = z.infer<typeof PaymentsAppointmentDetailsAmountSchema>
export type PaymentsAppointmentDetailsStatus = z.infer<typeof PaymentsAppointmentDetailsStatusSchema>
export type AppointmentPayment = z.infer<typeof AppointmentPaymentSchema>
export type PaymentsAppointmentDetailsSummary = z.infer<typeof PaymentsAppointmentDetailsSummarySchema>
export type PaymentsAppointmentDetails = z.infer<typeof PaymentsAppointmentDetailsSchema>
export type GetPaymentsAppointmentDetailsResponse = z.infer<typeof GetPaymentsAppointmentDetailsResponseSchema>
